import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
var _obj;
/**
 * @deprecated use #getTwoLetterLanguageCode
 */ export var THREE_TO_TWO_LETTER_LANGUAGE_CODE = (_obj = {}, _define_property(_obj, Language.ENG, "EN"), _define_property(_obj, Language.FRA, "FR"), _define_property(_obj, Language.DEU, "DE"), _define_property(_obj, Language.ITA, "IT"), _define_property(_obj, Language.SPA, "ES"), _define_property(_obj, Language.SWE, "SV"), _define_property(_obj, Language.DAN, "DA"), _define_property(_obj, Language.POR, "PT"), _define_property(_obj, Language.NLD, "NL"), _define_property(_obj, Language.GIBBERISH, "XA"), _define_property(_obj, Language.STRING_ID, "XC"), // Adding to ease testing
_define_property(_obj, "JPN", "JA"), _obj);
export function getTwoLetterLanguageCode(key) {
    return THREE_TO_TWO_LETTER_LANGUAGE_CODE[key];
}
